import Container from '@/components/container/Container';
import {
	NO_DATA_AVAILABLE,
	SOMETHING_WENT_WRONG,
} from '@/constants/empty-states';
import EmptyState from '@/modules/home/components/empty-state/EmptyState';

type Props = {
	isError: boolean | null;
	height?: string;
};
const EmptyScreen = ({ height = 'h-[196px]', isError }: Props) => {
	if (!isError) {
		return (
			<Container className={`flex place-self-center ${height}`}>
				<EmptyState
					title={NO_DATA_AVAILABLE}
					variant="circle"
					bgColor="bg-transparent"
				/>
			</Container>
		);
	}

	return (
		<Container className={`flex place-self-center ${height}`}>
			<EmptyState
				title={SOMETHING_WENT_WRONG}
				variant="triangle"
				bgColor="bg-transparent"
			/>
		</Container>
	);
};

export default EmptyScreen;
